import React, { useContext } from 'react'
import { ConfigContext, BridgeManageContext } from '@/utils/contextStatic'
import ScCoin from '@/components/Section/ScCoin'
import ScLink from '@/components/Section/ScLink'
import { RouterProps } from '@/utils/interface'
import { _numComma } from '@/utils/comMethod'
import withRouter from '@/utils/withRouter'
import useCommon from '@/hooks/useCommon'
import { RewardStyle } from './styled'
import Text from '@/components/Text'

const Reward:React.FC<RouterProps> = ({ t }) => {

  const { isPC } = useContext(ConfigContext)

  const { _getChainProperty, _getExchangePrice } = useCommon()
  
  const { lpBalance, poolInfo, tokenBalance } = useContext(BridgeManageContext)

  const { pool_symbol, chain_id, pool_contract, staking_token, last_balance, pool_apy } = poolInfo

  const chainSymbol = _getChainProperty(chain_id, 'chain_symbol')

  const chainName = _getChainProperty(chain_id, 'chain_name')

  // 渲染 - Position
  const positionRender = () => {
    const list:any = []
    const positionList:any = {
      'PoolPosition': [
        { coinName: pool_symbol, coinAmount: last_balance, explain: 'TotalLiquidity', isLp: true },
      ],
      'MyPosition': [
        { coinName: pool_symbol, coinAmount: lpBalance, explain: 'MyLiquidity', isLp: true },
        { coinName: pool_symbol, coinAmount: tokenBalance, explain: 'AddableLiquidity', isLp: false }
      ],
    }
    Object.keys(positionList).forEach((key:any) => {
      list.push(<Text key={`position_${key}`} clsName='title-item' kind='Bold' size={isPC ? '20' : '16'}>{ t(`Title.${key}`) }</Text>)
      positionList[key].forEach((item:any) => {
        const { coinName, coinAmount, explain, isLp } = item
        const showName = isLp ? `${coinName}-LP` : coinName
        list.push(
          <div key={`position_${explain}`} className='position-item'>
            <div>
              <ScCoin isSpecial={true} kind={isPC ? '16' : '17'} content={showName} name={coinName} isLp={isLp} />
              <Text kind='Bold' size={isPC ? '20' : '16'} type='specialNumber'>{_numComma(coinAmount, 4)}</Text>
            </div>
            <div>
              <Text size={isPC ? '13' : '12'} type='english' color='gray500'>{t(`Field.${explain}`)}</Text>
              <Text size={isPC ? '13' : '12'} type='number' color='gray500'>~ $ {_getExchangePrice(showName, coinAmount)}</Text>
            </div>
          </div>
        )
      })
    })
    return list
  }

  return (
    <RewardStyle>
      <div>{positionRender()}</div>
      <div>
        <Text kind='Bold' size={isPC ? '20' : '16'}>{ `${pool_symbol} Pool Info` }</Text>
        <div>
          <Text size={isPC ? '16' : '14'} type='english'>Chain</Text>
          <ScCoin kind={isPC ? '12' : '8'} content={chainName} name={chainSymbol} imgType='chain' />
        </div>
        <div>
          <Text size={isPC ? '16' : '14'} type='english'>APY</Text>
          <Text kind='Bold' size={isPC ? '16' : '14'} type='number'>{_numComma(pool_apy*100)}%</Text>
        </div>
        <div>
          <Text size={isPC ? '16' : '14'} type='english'>{pool_symbol} {t('Field.Contract')}</Text>
          <ScLink address={staking_token} query='token' />
        </div>
        <div>
          <Text size={isPC ? '16' : '14'} type='english'>{pool_symbol}-LP {t('Field.Contract')}</Text>
          <ScLink address={pool_contract} query='token' />
        </div>
      </div>
    </RewardStyle>
  )
}

export default withRouter(Reward)
